'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var style = {"tabPanel":"TabPanel-module_tabPanel__VyCvp","tab":"TabPanel-module_tab__-quHk"};

exports["default"] = style;
